<template>
	<div>
		<loader :dialog="loading"></loader>
		<v-dialog persistent v-model="showDialog" width="480">
			<v-card rounded="xl" class="pa-2">
				<div class="otp-header">
					<div class="otp-icon-box">
						<v-icon size="18" color="white">mdi-shield-key</v-icon>
					</div>
					<div>
						<p class="otp-title">Validation OTP</p>
						<p class="otp-subtitle">Code de sécurité à 4 chiffres</p>
					</div>
				</div>

				<v-divider></v-divider>

				<v-card-text class="pt-5 pb-3 text-center">
					<v-otp-input
						length="4"
						v-model="otpData"
						type="number"
						plain
					></v-otp-input>
					<v-alert
						type="info"
						dense
						text
						rounded="xl"
						class="mt-4 text-left"
						icon="mdi-information-outline"
					>
						Merci de contacter l'administrateur pour recevoir le
						code !
					</v-alert>
				</v-card-text>

				<v-card-actions class="pa-4 pt-0">
					<v-spacer></v-spacer>
					<v-btn
						:disabled="otpData.length < 4"
						depressed
						rounded
						class="otp-btn"
						@click="sendOtp"
					>
						Valider
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import services from "../services";
import Loader from "./Loader.vue";
export default {
	props: ["dialog"],
	components: { Loader },
	data() {
		return {
			otpData: "",
			loading: false,
		};
	},
	computed: {
		showDialog() {
			return this.dialog === true;
		},
	},
	methods: {
		sendOtp() {
			this.loading = true;
			services
				.otp({ otp: this.otpData })
				.then(() => {
					window.location.reload();
				})
				.catch((err) => {
					console.log(err);
					this.loading = false;
				});
		},
	},
};
</script>

<style scoped>
.otp-header {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 18px 20px 14px;
}
.otp-icon-box {
	width: 38px;
	height: 38px;
	border-radius: 10px;
	background: linear-gradient(135deg, #c62828, #1565c0);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.otp-title {
	font-size: 0.92rem;
	font-weight: 700;
	color: #111827;
	margin: 0 0 2px;
	font-family: Montserrat, sans-serif;
}
.otp-subtitle {
	font-size: 0.72rem;
	color: #9ca3af;
	margin: 0;
	font-family: Montserrat, sans-serif;
}
.otp-btn {
	background: #c62828 !important;
	color: white !important;
	font-family: Montserrat, sans-serif;
	font-weight: 700;
	font-size: 0.82rem;
	letter-spacing: 0.5px;
	padding: 0 28px;
	height: 40px;
}
</style>

